import getEditorListWebsite from "./getEditorListWebsite";

const editorWebsiteServices = {
  getEditorListWebsite,
};

export default editorWebsiteServices;
